import { OkrSession } from "server/models"
import { inferLiteral } from "client/utils"
import { TableGroupedIds } from "client/components"
import * as types from "./types"


export const setOkrSessionList = (sessionList: types.OkrSessionList) => ({
    type: inferLiteral(types.OKR_SESSION_LIST),
    sessionList,
})
export const setOkrSessionIds = (sessionIds: TableGroupedIds[]) => ({
    type: inferLiteral(types.OKR_SESSION_IDS),
    sessionIds,
})
export const setOkrSessionView = (session: OkrSession) => ({
    type: inferLiteral(types.OKR_SESSION_VIEW),
    session,
})
export const setOkrSessionEdit = (session: OkrSession) => ({
    type: inferLiteral(types.OKR_SESSION_EDIT),
    session,
})

// to select parent
export const setOkrSessionAvailableSessions = (sessions: OkrSession[]) => ({
    type: inferLiteral(types.OKR_SESSION_AVAILABLE_SESSIONS),
    sessions,
})

// popup menu
export const setOkrSessionActive = (active: OkrSession) => ({
    type: inferLiteral(types.OKR_SESSION_ACTIVE),
    active,
})
export const setOkrSessionPopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.OKR_SESSION_POPUP_MENU_SHOW),
    show,
})
export const setOkrSessionPopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.OKR_SESSION_POPUP_MENU_TARGET),
    target,
})
export const setOkrSessionShowConfirmDelete = (show: boolean) => ({
    type: inferLiteral(types.OKR_SESSION_SHOW_CONFIRM_DELETE),
    show,
})


export const setOkrSessionShowArchived = (show: boolean) => ({
    type: inferLiteral(types.OKR_SESSION_SHOW_ARCHIVED),
    show,
})


export const setOkrSessionReloadList = (value: boolean) => ({
    type: inferLiteral(types.OKR_SESSION_RELOAD_LIST),
    value,
})
export const setOkrSessionReloadView = (value: boolean) => ({
    type: inferLiteral(types.OKR_SESSION_RELOAD_VIEW),
    value,
})
export const setOkrSessionReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.OKR_SESSION_RELOAD_EDIT),
    value,
})
